import Attachments from "./Attachments";

import { useOutletContext } from "react-router";
import Forms from "./Forms";
import { IoLocationSharp } from "react-icons/io5";
import { Translate } from "react-localize-redux";
import { useEffect, useState } from "react";

const FormContentLayout = () => {
  const [subFormsList, setSubFormsList] = useState([]);
  const [mainLocation, setMainLocation] = useState("");

  // eslint-disable-next-line no-unused-vars
  const {
    isReadOnly,
    subForms,
    editedSubForms,
    settings,
    selectedLocation,
    handleAddRemoveRepeatableForm,
    handleUpdateFormField,
    isLock,
    attachments,
    setIsAttachmentsUpdated,
    setAttachments,
    translate,
    handleUpdateFormFieldAttachment,
    handleKeepOldForm,
  } = useOutletContext();

  useEffect(() => {
    if (isReadOnly) setSubFormsList(subForms);
    else setSubFormsList(editedSubForms);
  }, [editedSubForms, isReadOnly, subForms]);

  useEffect(() => {
    const paths = selectedLocation?.path?.split(">");
    if (paths && paths.length > 1) {
      setMainLocation(paths[paths.length - 1].trim());
    }
  }, [selectedLocation]);

  return (
    <>
      <div className="row py-3 border-top border-2 ps-3">
        <div className="col-12 py-2">
          <div className="location-info-area d-flex justify-content-start align-items-start">
            <span>
              <IoLocationSharp className="fs-3 text-orange me-2" />
            </span>
            <div className="locations d-flex flex-column align-items-start">
              <div className="main-location mb-2">{mainLocation}</div>
              <div className="location-breadcrumbs text-gray">
                {selectedLocation?.path}
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 py-2">
          <p className="fs-5 text-orange mt-3 mb-0">
            <Translate id="forms.form_data" />
          </p>
        </div>
      </div>
      {/** Form Information */}

      <Forms
        forms={subFormsList}
        handleAddRemoveRepeatableForm={handleAddRemoveRepeatableForm}
        handleUpdateFormField={handleUpdateFormField}
        location={selectedLocation}
        language={settings.language}
        isEditing={!isReadOnly}
        translate={translate}
        handleUpdateFormFieldAttachment={handleUpdateFormFieldAttachment}
        handleKeepOldForm={handleKeepOldForm}
      />
      {/** Form Information */}

      {/** Attachments */}
      <div>
        <Attachments
          title="Attachments"
          data={attachments}
          disabled={isReadOnly}
          isLock={isLock}
          setIsUpdated={setIsAttachmentsUpdated}
          handleUpload={(files) => setAttachments(files)}
        />
      </div>
      {/** Attachments */}
    </>
  );
};
export default FormContentLayout;
